// extracted by mini-css-extract-plugin
export default {"simplePanelLayout":"OrderHoursPanel_simplePanelLayout__dEf+L"};